import Vue from 'vue'
import Vuex from 'vuex'
import navCollapse from './navCollapse'
import userMenuData from './userMenuData'
import userInfo from './userInfo'
import softs from './softs'
import tableData from './tableData'
import publicData from './publicData'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    navCollapse,userMenuData,userInfo,softs,tableData,publicData
  }
})
